import { render } from "./AddXsdFiles.vue?vue&type=template&id=427e0f00"
import script from "./AddXsdFiles.vue?vue&type=script&lang=js"
export * from "./AddXsdFiles.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__